import type { InjectionKey } from 'vue'
import {
  ExtendedMeasureStatus,
  type MeasureRights,
  MeasureSortField,
  MeasureStatus,
  type Policy,
  RecurringControlType,
} from '@/contexts/security-base/SecurityBase.interfaces'
import { NdsTagColor } from '@/components/NewDesignSystem/NdsTag/NdsTag.interfaces'
import type { NdsChipSelectors } from '@/components/NewDesignSystem/NdsChipSelector/NdsChipSelector.interfaces'
import { NdsChipState } from '@/components/NewDesignSystem/NdsChip/NdsChip.interfaces'

export const MEASURE_STATUS = {
  ...MeasureStatus,
}

export const EXTENDED_MEASURE_STATUS = {
  ...ExtendedMeasureStatus,
}

export const MEASURES_META_STATUS = {
  ...MEASURE_STATUS,
  ALL: 'ALL',
}

export const MEASURE_SORT_FIELD = {
  ...MeasureSortField,
}

export const RECURRING_CONTROL_TYPE = {
  ...RecurringControlType,
}

export const MEASURE_RIGHTS: Readonly<Record<string, keyof MeasureRights>> = {
  CHANGE_STATUS: 'change_status',
  EDIT_BUILT_MEASURE: 'edit_built_measure',
  EDIT: 'edit',
  DELETE: 'delete',
}

export const MEASURE_STATUS_TRANSLATION_KEY: Readonly<Record<ExtendedMeasureStatus, string>> = {
  [EXTENDED_MEASURE_STATUS.TO_IMPLEMENT]: 'security_base.measure.status.to_implement',
  [EXTENDED_MEASURE_STATUS.NOT_IMPLEMENTED]: 'security_base.measure.status.not_implemented',
  [EXTENDED_MEASURE_STATUS.IMPLEMENTED]: 'security_base.measure.status.implemented',
  [EXTENDED_MEASURE_STATUS.IMPLEMENTED_BY]: 'security_base.measure.status.implemented_by',
}

export const EMPTY_MEASURES_TRANSLATION_KEY: Readonly<Record<MeasureStatus, string>> = {
  [MEASURE_STATUS.TO_IMPLEMENT]: 'security_base.measure.empty_list.to_implement',
  [MEASURE_STATUS.NOT_IMPLEMENTED]: 'security_base.measure.empty_list.not_implemented',
  [MEASURE_STATUS.IMPLEMENTED]: 'security_base.measure.empty_list.implemented',
}

export const MEASURE_STATUS_TAG_COLOR: Readonly<Record<ExtendedMeasureStatus, NdsTagColor>> = {
  [EXTENDED_MEASURE_STATUS.TO_IMPLEMENT]: NdsTagColor.NEUTRAL,
  [EXTENDED_MEASURE_STATUS.NOT_IMPLEMENTED]: NdsTagColor.WARNING,
  [EXTENDED_MEASURE_STATUS.IMPLEMENTED]: NdsTagColor.SUCCESS,
  [EXTENDED_MEASURE_STATUS.IMPLEMENTED_BY]: NdsTagColor.PRIMARY_100,
}

export const MEASURES_FILTERS_CHIPS: Readonly<NdsChipSelectors> = [
  {
    id: MEASURE_STATUS.TO_IMPLEMENT,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MEASURE_STATUS.TO_IMPLEMENT],
    counter: 0,
    state: NdsChipState.NEUTRAL,
  },
  {
    id: MEASURE_STATUS.NOT_IMPLEMENTED,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MEASURE_STATUS.NOT_IMPLEMENTED],
    counter: 0,
    state: NdsChipState.WARNING,
  },
  {
    id: MEASURE_STATUS.IMPLEMENTED,
    labelKey: MEASURE_STATUS_TRANSLATION_KEY[MEASURE_STATUS.IMPLEMENTED],
    counter: 0,
    state: NdsChipState.SUCCESS,
  },
]

export const MEASURES_FILTERS_ID: Readonly<Record<string, string>> = {
  ACTIONS: 'actions',
  RISKS: 'risks',
  EFFICIENCY: 'efficiency',
  SCORE: 'score',
}

export const MEASURES_FILTERS_ACTIONS: Readonly<Record<string, string>> = {
  WITH_ACTIONS: 'with-actions',
  WITHOUT_ACTIONS: 'without-actions',
}

export const MEASURES_FILTERS_RISKS: Readonly<Record<string, string>> = {
  WITH_RISKS: 'with-risks',
  WITHOUT_RISKS: 'without-risks',
}

export const MEASURES_FILTERS_SCORE: Readonly<Record<string, string>> = {
  DEFAULT: 'default',
  WITH_CONTROLS: 'with-controls',
}

export const IMPACT_OPTIONS = {
  NEUTRAL: 'NEUTRAL',
  MINOR: 'MINOR',
  MAJOR: 'MAJOR',
  CUSTOM: 'CUSTOM',
}

export const IMPACT_BY_OPTIONS: Record<string, number> = {
  [IMPACT_OPTIONS.NEUTRAL]: 0,
  [IMPACT_OPTIONS.MINOR]: 25,
  [IMPACT_OPTIONS.MAJOR]: 50,
}

export const OPEN_REMOVE_POLICY_MODAL_KEY: InjectionKey<(policy: Policy) => void> = Symbol('openRemovePolicyModal')

export const SECURITY_BASE_ROUTE_NAMES: Record<string, string> = {
  MEASURES: 'security_base_measures',
  PERIMETERS: 'security_base_perimeters',
  POLICIES: 'security_base_policies',
  MEASURES_DIFFERENCES: 'security_base_measures_differences',
}
